<section *ngIf="data" class="profiles-panel" #panelEl>
  <top-wave *ngIf="data.topWave.value"></top-wave>
  <div class="profiles-panel__content">
    <h2 *ngIf="data.title" class="profiles-panel__title" #titleEl>
      {{ data.title.value }}
    </h2>
    <div
      *ngIf="data.subtitle"
      class="profiles-panel__subtitle"
      [innerHTML]="data.subtitle.value"
      #subtitleEl
    ></div>

    <div
      class="profiles-panel__cards"
      #profileEl
      [ngClass]="{
        'profiles-panel__cards--not-full': data.items.value.length !== 3
      }"
    >
      <div
        *ngFor="let item of data.items.value; let i = index"
        class="profiles-panel__card-wrapper"
        #profilesEl
      >
        <div
          class="profiles-panel__card"
          [ngClass]="{ 'profiles-panel__card--opened': item.state == 'opened' }"
          (click)="toggleItemState(item)"
        >
          <div #imageEl class="profiles-panel__card-img"></div>
          <div *ngIf="item.author?.value" class="profiles-panel__card-author">
            {{ item.author.value }}
          </div>
          <div
            *ngIf="item.position?.value"
            class="profiles-panel__card-position"
          >
            {{ item.position.value }}
          </div>
          <div class="profiles-panel__card__description-toggle">
            <div
              class="profiles-panel__card-description"
              [@animation]="item.state"
              [innerHTML]="item.description.value | safe"
            ></div>
            <div class="profiles-panel__description-arrow">
              <svg
                [@arrow]="item.state"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="data.bottomText.value"
      [innerHTML]="data.bottomText.value"
      #bottomTextEl
      class="profiles-panel__page__description"
    ></div>
  </div>
  <bottom-wave *ngIf="data.bottomWave.value"></bottom-wave>
</section>
